import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { formatDate, formatTime } from "../../utils/dateTimeFormat";

const taskss = [
  {
    id: 1,
    status: "Completed",
    title: "Buy Groceries",
    date: "12 July, 2025",
    time: "5:30 PM",
    priority: "High Priority",
    category: "Work",
    location: "Apptunix Sector 77, Mohali",
    sharedWith: ["Alex Morgan", "Divya Kapoor"],
    repeat: "Daily",
    reminder: "10 min before",
  },
  {
    id: 2,
    status: "Pending",
    title: "Prepare Presentation",
    date: "24 July, 2025",
    time: "10:00 AM",
    priority: "High Priority",
    category: "Work",
    location: "Office",
    sharedWith: ["John Doe"],
    repeat: "One-Time",
    reminder: "30 min before",
  },
  {
    id: 3,
    status: "Pending",
    title: "Doctor Appointment",
    date: "25 July, 2025",
    time: "03:30 PM",
    priority: "Low Priority",
    category: "Health",
    location: "Apollo Clinic",
    sharedWith: [],
    repeat: "One-Time",
    reminder: "1 hour before",
  },
];

const TaskViewList = ({ tasks }: { tasks?: any }) => {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <SearchBar
            searchTerm={searchTerm}
            setDebouncedSearchTerm={setSearchTerm}
            placeholder="Search..."
          />
          <div className="form">
            <div className="control_group">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="form_control"
                  slots={{
                    openPickerIcon: () => (
                      <img src="/static/images/date_icon.svg" alt="icon" />
                    ),
                  }}
                  slotProps={{
                    textField: {
                      placeholder: "Select Date",
                      fullWidth: true,
                      hiddenLabel: true,
                    },
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                />
              </LocalizationProvider>
            </div>
          </div>
        </div>
      </div>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Status</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Time</TableCell>
              <TableCell>Priority</TableCell>
              <TableCell>Category</TableCell>
              {/* <TableCell>Location</TableCell> */}
              <TableCell>Shared With</TableCell>
              <TableCell>Repeat</TableCell>
              <TableCell>Reminder</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tasks.length > 0 &&
              tasks.map((task: any) => (
                <TableRow key={task.id}>
                  <TableCell>
                    <span
                      className={`status_btn ${
                        task.status === "Completed" ? "c_success" : "c_warning"
                      }`}
                    >
                      {task.status}
                    </span>
                  </TableCell>
                  <TableCell>{task.title}</TableCell>
                  <TableCell>{formatDate(task.time)}</TableCell>
                  <TableCell>{formatTime(task.time)}</TableCell>
                  <TableCell>{task.priority}</TableCell>
                  <TableCell>{task.category}</TableCell>
                  <TableCell>
                    {task.shared_with?.length
                      ? task?.shared_with
                          ?.map((item: any) => item.first_name)
                          .join(", ")
                      : "-"}
                  </TableCell>
                  <TableCell>{task.repeat_every}</TableCell>
                  <TableCell>{task.task_reminder}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TaskViewList;
